import { Component, OnInit, Input, DoCheck, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { CalculationService } from '../services/calculation.service';
import { FormDataService } from '../services/form-data.service';

@Component({
  selector: 'app-protect-plus',
  templateUrl: './protect-plus.component.html',
  styleUrls: ['./protect-plus.component.scss'],
  standalone: false
})
export class ProtectPlusComponent implements OnInit, DoCheck, OnChanges {
  @Input('dataJSON') dataJSON: any;
  @Output('sendJSONWithPrem') sendJSONWithPrem = new EventEmitter<any>();
  @Output('isCrillAndSecMedOPChecked') isCrillAndSecMedOPChecked1 = new EventEmitter<boolean>();
  @Input('lightCheck') lightCheck: boolean;
  @Input('protectCheck') protectCheck: boolean;
  @Input('hideIllnessWhenOver65Years') hideIllnessWhenOver65Years: boolean;

  private bornDate: string;
  private years: number;
  private amoutOfMoney: number;
  private currency: string; // "BGN" or "EUR"
  private selectedPaymentType: number; // "1" / "12"
  public isExtendedPartActive: boolean = false;
  private crill: string;
  private secondMedOp: string;
  private isCrillAndSecMedOPChecked: boolean = false;
  private isCrillDescriptionActive: boolean = false;
  private isSecondMedicalOpinionDescriptionActive: boolean = false;
  private manPrem: number;
  private previousManPrem: number;
  private returnedData: any = [];
  jsonObjectWithPremium: any = {};

  // variables that show or hide some message on the screen
  private isThereEmptyField: boolean = false;
  private isBornDateCharactersCorrect: boolean = true;
  private isBornDateMonthAndDayCorrect: boolean = true;
  private isBornDateLengthCorrect: boolean = true;
  private isBornDateCorrect: boolean = true;
  private isYearsOfDurationCorrect: boolean = true;
  public removePackages: boolean = false;

  constructor(private calculationService: CalculationService, private data: FormDataService) { }

  ngOnInit() {
    this.data.currentRemovePackages.subscribe(removePackages => this.removePackages = removePackages);
  }

  ngDoCheck() {

    if(this.removePackages){
      this.isCrillAndSecMedOPChecked = false;
      this.crill = "N";
      this.secondMedOp = "N";
    }
    this.bornDate = this.dataJSON.bornDate;
    this.years = this.dataJSON.years;
    this.amoutOfMoney = this.dataJSON.amoutOfMoney;
    this.currency = this.dataJSON.currency;
    this.selectedPaymentType = this.dataJSON.selectedPaymentType;
    if (this.isCrillAndSecMedOPChecked) {
      this.crill = "Y";
      this.secondMedOp = "Y";
    }
    else {
      this.crill = "N";
      this.secondMedOp = "N";
    }

    // console.log('plus - this.manPrem, this.previousManPrem', this.manPrem, this.previousManPrem);
    // if (this.manPrem != this.previousManPrem) {
    //   this.changePrem(this.jsonObjectWithPremium);
    //   this.previousManPrem = this.manPrem;
    // }
  }

  onCheckboxClick(){
    setTimeout(()=>{this.isCrillAndSecMedOPChecked1.emit(this.isCrillAndSecMedOPChecked)},0)
  }


  ngOnChanges(changes: SimpleChanges) {
    if( ( changes.lightCheck && changes.lightCheck.currentValue ) || ( changes.protectCheck && changes.protectCheck.currentValue ) )
      this.isCrillAndSecMedOPChecked = false;
  }

  showHideExtendedPart() {
    this.isExtendedPartActive = !this.isExtendedPartActive;
  }

  changePrem(newJSONWithPrem: any) {
    this.sendJSONWithPrem.emit(newJSONWithPrem);
  }

  showHideCrillDescription() {
    this.isCrillDescriptionActive = !this.isCrillDescriptionActive;
  }

  showHideSecondMedicalOpinionDescription() {
    this.isSecondMedicalOpinionDescriptionActive = !this.isSecondMedicalOpinionDescriptionActive;
  }

  calculate() {
    this.returnedData = [];

    // Validation - check are all inputs correct
    this.isThereEmptyField = false;
    this.isBornDateCharactersCorrect = true;
    this.isBornDateMonthAndDayCorrect = true;
    this.isBornDateLengthCorrect = true;
    this.isBornDateCorrect = true;
    this.isYearsOfDurationCorrect = true;

    if (!this.bornDate || !this.years || !this.amoutOfMoney || !this.currency || !this.selectedPaymentType) {
      this.isThereEmptyField = true;
    }
    else {
      this.isThereEmptyField = false;

      if (new RegExp(/^[0-9\-]+$/).test(this.bornDate)) {
        this.isBornDateCharactersCorrect = true;

        const dateParts = this.bornDate.split("-");
        const month = parseInt(dateParts[1], 10);
        const day = parseInt(dateParts[2], 10);
        
        if (month >= 1 && month <= 12 && day >= 1 && day <= 31) {
          this.isBornDateMonthAndDayCorrect = true;

          if (new String(this.bornDate).toString().length === 10) {
            this.isBornDateLengthCorrect = true;

            let userYears = new Date().getFullYear() - new Date(this.bornDate).getFullYear();

            if (userYears >= 14 && userYears <= 60) {
              this.isBornDateCorrect = true;

              if ((userYears + this.years) <= 70) {
                this.isBornDateCorrect = true;

                if (this.years >= 10 && this.years <= 30) {
                  this.isYearsOfDurationCorrect = true;

                  // send the JSON with the data
                  this.calculationService.sendDataForCalculation(
                    this.crill, // при включени тежки заболявания - "Y" or "N"
                    this.secondMedOp, // при включено второ медицинско мнение - - "Y" or "N"
                    this.bornDate,
                    this.years,
                    this.amoutOfMoney,
                    this.currency,
                    this.selectedPaymentType,
                    "Y", //  'Y' -> Включено СМЪРТ ОТ ЗЛОПОЛУКА, 'N' -> Без СМЪРТ ОТ ЗЛОПОЛУКА
                    1, //  0 -> Без БОЛНИЧЕН ПРЕСТОЙ, 1 -> Включен БОЛНИЧЕН ПРЕСТОЙ ОТ ЗЛОПОЛУКА, 2 -> Включен БОЛНИЧЕН ПРЕСТОЙ ОТ ЗЛОПОЛУКА ИЛИ ЗАБОЛЯВАНЕ
                    1, //  0 -> Без РАЗХОДИ ЗА ЛЕКАРСТВА, 1 -> Включен РАЗХОДИ ЗА ЛЕКАРСТВА ОТ ЗЛОПОЛУКА, 2 -> Включен РАЗХОДИ ЗА ЛЕКАРСТВА ОТ ЗЛОПОЛУКА ИЛИ ЗАБОЛЯВАНЕ
                    1, // 0 -> Без ВРЕМЕННА ЗАГУБА НА ТРУДОСПОСОБНОСТ,   1 -> Включена ВРЕМЕННА ЗАГУБА НА ТРУДОСПОСОБНОСТ ОТ ЗЛОПОЛУКА, 2 -> Включена ВРЕМЕННА ЗАГУБА НА ТРУДОСПОСОБНОСТ ОТ ЗЛОПОЛУКА ИЛИ ЗАБОЛЯВАНЕ
                    1 //0 -> Без ТРАЙНА ЗАГУБА НА ТРУДОСПОСОБНОСТ, 1 -> Включен ТРАЙНА ЗАГУБА НА ТРУДОСПОСОБНОСТ ОТ ЗЛОПОЛУКА, 2 -> Включен ТРАЙНА ЗАГУБА НА ТРУДОСПОСОБНОСТ ОТ ЗЛОПОЛУКА ИЛИ ЗАБОЛЯВАНЕ
                  ).subscribe(
                    resultData => {
                      this.returnedData.push(resultData);
                      // console.log("The returndData: ", this.returnedData);
                      // console.log("The result: ", resultData);
                      // console.log("The manPrem: ", this.returnedData[0].payload.CalcPrem[0].PREMIUM);
                      // construct JSON including all checkboxes values and returned premium
                      this.jsonObjectWithPremium = {
                        manPrem: this.returnedData[0].payload.CalcPrem[0].PREMIUM,
                        selectedPackage: "protectPlus",
                        customPackage: "N",
                        crill: this.crill,
                        secondMedOp: this.secondMedOp,
                        death: "Y",
                        stayAtHospital: 1,
                        expenditureForMedicines: 1,
                        temporraryLossOfEmployment: 1,
                        longTermLossOfEmployment: 1
                      }
                      this.manPrem = this.returnedData[0].payload.CalcPrem[0].PREMIUM;
                      this.changePrem(this.jsonObjectWithPremium);
                    },
                    err => {
                      console.log("Error has occured: ", err);
                    }
                    );
                }
                else {
                  this.isYearsOfDurationCorrect = false;
                }
              }
              else {
                this.isBornDateCorrect = false;
              }
            }
            else {
              this.isBornDateCorrect = false;
            }
          }
          else {
            this.isBornDateLengthCorrect = false;
          }
        }
        else {
          this.isBornDateMonthAndDayCorrect = false;
        }
      }
      else {
        this.isBornDateCharactersCorrect = false;
      }
    }

  }
}
